import * as React from "react"

export type Props = {
	name?:string
	value?:string
	disabled?:boolean
	onChange?:(newText:string) => void
	className?:string
	style?: React.CSSProperties
}

export const Textarea = (props:Props) => <textarea
	name={props.name}
	disabled={props.disabled}
	onChange={(event:React.FormEvent<HTMLTextAreaElement>) => {
		event.stopPropagation()
		if (props.onChange) {
			props.onChange(event.currentTarget.value)
		}
	}}
	className={`sbTextAreaOff${props.className ? ' ' + props.className : ''}`}
	value={props.value}
	style={props.style || {}}
/>



// WEBPACK FOOTER //
// ./src/lib/sbhtml/textarea.tsx